"use client";

import React from 'react';
import { useCheckoutCancel } from '../hooks/useCheckoutFlow';

export interface CheckoutCancelProps {
  onCancel?: (planId: string | null) => void;
  retryUrl?: string;
  redirectUrl?: string;
  className?: string;
  showRetryButton?: boolean;
}

export function CheckoutCancel({
  onCancel,
  retryUrl,
  redirectUrl,
  className = "",
  showRetryButton = true
}: CheckoutCancelProps) {
  const { planId, isCancelled } = useCheckoutCancel();

  React.useEffect(() => {
    if (isCancelled) {
      onCancel?.(planId);
    }
  }, [isCancelled, planId, onCancel]);

  const handleRetry = () => {
    if (retryUrl) {
      window.location.href = retryUrl;
    } else {
      window.history.back();
    }
  };

  const handleGoHome = () => {
    window.location.href = redirectUrl || '/';
  };

  return (
    <div className={`flex items-center justify-center min-h-screen ${className}`}>
      <div className="text-center max-w-md">
        <svg
          className="mx-auto h-16 w-16 text-gray-400 mb-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        
        <h1 className="text-3xl font-bold mb-4">Payment Cancelled</h1>
        
        <p className="text-lg text-muted-foreground mb-6">
          Your payment was cancelled. No charges have been made to your account.
        </p>
        
        {planId && (
          <p className="text-sm text-muted-foreground mb-6">
            You were trying to subscribe to: <span className="font-mono">{planId}</span>
          </p>
        )}
        
        <div className="space-y-3">
          {showRetryButton && (
            <button
              onClick={handleRetry}
              className="w-full bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary/90 transition"
            >
              Try Again
            </button>
          )}
          
          <button
            onClick={handleGoHome}
            className="w-full bg-gray-100 text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition"
          >
            Back to Home
          </button>
        </div>
        
        <p className="text-xs text-muted-foreground mt-6">
          Need help? Contact our support team.
        </p>
      </div>
    </div>
  );
}